import gql from 'graphql-tag'

export default gql`
{
  items(
    sort: CHECKOUTAT_DESC
    limit: 500
  ) {
    _id
    itemId
    checkOutAt
    checkOutBy {
      name
    }
    checkOutStock
    product {
      name
      size
      color
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/checkOutItems.js